import { INextStep } from '../../cachedEntities';
import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IBuilder, RowType } from '../types';
import { assertCondition } from '../../../../utils/types';
import {
  parseBreakdownToStatePayload,
  parseGlobalCohortsToStatePayload,
} from '../../../../components/Builder/utils/builderUtils';
import prepareExpressionToNextStep from './prepareExpressionToNextStep';
import preparePathToNextStep from './preparePathToNextStep';
import prepareRetentionToNextStep from './prepareRetentionToNextStep';
import prepareDataTableToNextStep from './prepareDataTableToNextStep';
import prepareFunnelToNextStep from './prepareFunnelToNextStep';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';

export const populateNextStepReducer = (
  draft: Draft<IBuilder>,
  action: PayloadAction<INextStep>,
) => {
  const { builderInfo, timeUnit, targetType, dateInput } = action.payload;

  const currentQueryType = draft.queryType;

  // Before all, make sure that we do it for correct report
  assertCondition(currentQueryType && currentQueryType === targetType);

  // Populate Report Filters and Group By(groups, segments, and settings)
  const { schema, breakdown, cohortRefs, filter } = builderInfo;

  const { builderBreakdown, breakdownCohorts } = parseBreakdownToStatePayload(
    breakdown,
    currentQueryType,
  );

  draft.activeSchemaId = schema.id;
  draft[RowType.globalCohorts] = parseGlobalCohortsToStatePayload(cohortRefs);
  draft.breakdown = {
    ...builderBreakdown,
    // KB-7399: Data Table doesn't have the Overall toggle
    overall:
      targetType === QueryType.DataTable ? false : builderBreakdown.overall,
  };
  draft[RowType.breakdownCohorts] = breakdownCohorts;

  if (filter) {
    draft.filter = filter;
  }

  draft.dateInput = dateInput;

  // Based on provided builderInfo and target type,
  // we have to parse builderInfo to properly populate Builder with
  // needed information
  if (builderInfo.__typename === 'ExpressionQuery') {
    prepareExpressionToNextStep(draft, builderInfo, targetType, timeUnit);
  } else if (builderInfo.__typename === 'PathQuery') {
    preparePathToNextStep(draft, builderInfo, targetType);
  } else if (builderInfo.__typename === 'RetentionQuery') {
    prepareRetentionToNextStep(draft, builderInfo, targetType);
  } else if (builderInfo.__typename === 'DataTableQuery') {
    prepareDataTableToNextStep(draft, builderInfo, targetType);
  } else if (builderInfo.__typename === 'FunnelQuery') {
    prepareFunnelToNextStep(draft, builderInfo, targetType, timeUnit);
  }
};
